// Hear a notification sound before choosing it — the ▶ beside a Sound picker.
//
// ⚠️ THE FILES ARE THE APK'S. On Android 8+ the notification CHANNEL owns the
// sound, so the real files live in android/app/src/main/res/raw. The dev server
// serves that folder at /sounds (craco.config.js), and `npm run ship` copies it
// into the two WEB builds (production, staging) — never into the OTA zip or the
// APK a second time. So preview (and the desktop's RF bell, ui/shared/rfBell.js)
// works in a desktop browser; inside the app it is hidden.
// On a phone, "Send a test" plays the real thing through the real channel.
//
// ⚠️ EXTENSIONS DIFFER (four .wav, the rest .mp3) and the channel names carry
// none, so this map is the one place that knows. A sound added to res/raw and
// pushChannels.SOUNDS must be added here too, or its ▶ says "not available".

import { isNativePlatform } from '../platform';

const FILES = {
  sound1: 'sound1.wav',
  sound2: 'sound2.wav',
  sound3: 'sound3.mp3',
  sound4: 'sound4.wav',
  sound5: 'sound5.wav',
  sound6: 'sound6.mp3',
  telephone_ring: 'telephone_ring.wav',
  main_door_opened: 'main_door_opened.mp3',
  main_door_closed: 'main_door_closed.mp3',
  smartify: 'smartify.mp3',
  smartify_male: 'smartify_male.mp3',
  smartclick: 'smartclick.mp3',
  smartsecure: 'smartsecure.mp3',
  smartppagar: 'smartppagar.mp3',
  sharpaccounting: 'sharpaccounting.mp3',
  alarm_siren: 'alarm_siren.wav',
  alarm_yelp: 'alarm_yelp.wav',
  alarm_hilo: 'alarm_hilo.wav',
  alarm_beep_fast: 'alarm_beep_fast.wav',
  alarm_klaxon: 'alarm_klaxon.wav',
  alarm_panic: 'alarm_panic.wav',
  warning_chime: 'warning_chime.wav',
  warning_pulse: 'warning_pulse.wav',
  beep_single: 'beep_single.wav',
  beep_double: 'beep_double.wav',
  beep_triple: 'beep_triple.wav',
  beep_long: 'beep_long.wav',
  chirp_up: 'chirp_up.wav',
  chirp_down: 'chirp_down.wav',
  buzz_short: 'buzz_short.wav',
  ding_dong: 'ding_dong.wav',
  voice_close_door: 'voice_close_door.wav',
  voice_door_closed: 'voice_door_closed.wav',
};

/** The URL of a sound's file, or '' for 'default' / unknown. */
export function soundUrl(sound) {
  const file = FILES[String(sound || '').trim()];
  return file ? `${process.env.PUBLIC_URL || ''}/sounds/${file}` : '';
}

/** Can this build play a preview at all? A browser (dev server or a shipped web build), never the app. */
export const canPreviewSounds = () => !isNativePlatform();

let current = null;

/** Stop whatever is playing. */
export function stopSound() {
  if (current) {
    try { current.pause(); } catch (e) { /* ignore */ }
    current = null;
  }
}

/**
 * Play a sound. One at a time — a second press stops the first.
 * -> Promise<{ ok, error? }>; 'default' is the phone's own tone and has no file.
 */
export async function playSound(sound) {
  stopSound();
  const url = soundUrl(sound);
  if (!url) {
    // eslint-disable-next-line no-nested-ternary
    const why = sound === 'default' ? "General is the phone's own notification tone"
      : (sound === 'silent' ? 'Silent — the notification arrives with no sound' : 'no file for this sound');
    return { ok: false, error: why };
  }
  try {
    const a = new Audio(url);
    current = a;
    a.onended = () => { if (current === a) current = null; };
    await a.play();
    return { ok: true };
  } catch (e) {
    current = null;
    return { ok: false, error: 'could not play — is this `npm start`?' };
  }
}
